import { formatCurrencyValue } from '@/modules/common/lib/formatters';
import { IAmount } from '@/types/amount';
import { IUserWithProfile } from '@/types/user';
import { Typography } from '@mui/material';
import { ComponentProps } from 'react';

type ApplicationDetailsRowProps = {
  user: IUserWithProfile;
  applicationLearningBudgetAmount?: IAmount;
  remainingLearningBudget?: number;
  totalAmount: number;
  orderUserPaymentAmount?: IAmount;
} & ComponentProps<'div'>;

export function ApplicationDetailsRow({
  user,
  applicationLearningBudgetAmount,
  remainingLearningBudget,
  totalAmount,
  orderUserPaymentAmount,
  ...props
}: ApplicationDetailsRowProps) {
  return (
    <div
      {...props}
      className={`grid grid-cols-4 justify-center content-center gap-2 bg-light-gray p-4 rounded-xl ${props.className ?? ''}`}
    >
      <div className="flex flex-col">
        <Typography fontWeight={600}>
          {[user?.firstName, user?.lastName].filter(Boolean).join(' ')}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {user?.email}
        </Typography>
      </div>
      <div className="flex flex-col">
        <Typography fontWeight={600}>Budget request</Typography>
        <Typography color="text.secondary" fontWeight={600}>
          {applicationLearningBudgetAmount?.amount &&
          applicationLearningBudgetAmount?.currency
            ? formatCurrencyValue(
                applicationLearningBudgetAmount.amount.toString(),
                applicationLearningBudgetAmount.currency,
              )
            : '-'}
        </Typography>
      </div>
      <div className="flex flex-col">
        <Typography fontWeight={600}>Available</Typography>
        <Typography color="text.secondary" fontWeight={600}>
          {remainingLearningBudget
            ? formatCurrencyValue(remainingLearningBudget.toString(), 'EUR')
            : '-'}
        </Typography>
      </div>
      <div className="flex flex-col">
        <Typography fontWeight={600}>Total Cost</Typography>
        <Typography color="text.secondary" fontWeight={600}>
          {totalAmount
            ? formatCurrencyValue(
                totalAmount.toString(),
                orderUserPaymentAmount?.currency ?? 'eur',
              )
            : '-'}
        </Typography>
      </div>
    </div>
  );
}
